import * as Icons from './svg-icons';
export const IconMap = {
    '0': Icons.Svg0,
    '1': Icons.Svg1,
    '2': Icons.Svg2,
    '3': Icons.Svg3,
    '4': Icons.Svg4,
    '5': Icons.Svg5,
    '6': Icons.Svg6,
    '7': Icons.Svg7,
    '8': Icons.Svg8,
    '9': Icons.Svg9,
    '00': Icons.Svg00,
    a: Icons.A,
    'address-book': Icons.AddressBook,
    'address-card': Icons.AddressCard,
    'air-conditioner': Icons.AirConditioner,
    airplay: Icons.Airplay,
    'alarm-clock': Icons.AlarmClock,
    'alarm-exclamation': Icons.AlarmExclamation,
    'alarm-plus': Icons.AlarmPlus,
    'alarm-snooze': Icons.AlarmSnooze,
    'album-circle-plus': Icons.AlbumCirclePlus,
    'album-circle-user': Icons.AlbumCircleUser,
    'album-collection-circle-plus': Icons.AlbumCollectionCirclePlus,
    'album-collection-circle-user': Icons.AlbumCollectionCircleUser,
    'album-collection': Icons.AlbumCollection,
    album: Icons.Album,
    'align-center': Icons.AlignCenter,
    'align-justify': Icons.AlignJustify,
    'align-left': Icons.AlignLeft,
    'align-right': Icons.AlignRight,
    'align-slash': Icons.AlignSlash,
    alt: Icons.Alt,
    ampersand: Icons.Ampersand,
    'anchor-circle-check': Icons.AnchorCircleCheck,
    'anchor-circle-exclamation': Icons.AnchorCircleExclamation,
    'anchor-circle-xmark': Icons.AnchorCircleXmark,
    'anchor-lock': Icons.AnchorLock,
    anchor: Icons.Anchor,
    'angle-down-small': Icons.AngleDownSmall,
    'angle-down': Icons.AngleDown,
    'angle-left-small': Icons.AngleLeftSmall,
    'angle-left': Icons.AngleLeft,
    'angle-right-small': Icons.AngleRightSmall,
    'angle-right': Icons.AngleRight,
    'angle-up-small': Icons.AngleUpSmall,
    'angle-up': Icons.AngleUp,
    angle: Icons.Angle,
    'angles-down': Icons.AnglesDown,
    'angles-left': Icons.AnglesLeft,
    'angles-right': Icons.AnglesRight,
    'angles-up': Icons.AnglesUp,
    apartment: Icons.Apartment,
    aperture: Icons.Aperture,
    'apple-tv': Icons.AppleTv,
    'arrow-down-1-9': Icons.ArrowDown19,
    'arrow-down-9-1': Icons.ArrowDown91,
    'arrow-down-a-z': Icons.ArrowDownAz,
    'arrow-down-arrow-up': Icons.ArrowDownArrowUp,
    'arrow-down-big-small': Icons.ArrowDownBigSmall,
    'arrow-down-from-dotted-line': Icons.ArrowDownFromDottedLine,
    'arrow-down-from-line': Icons.ArrowDownFromLine,
    'arrow-down-left-and-arrow-up-right-to-center': Icons.ArrowDownLeftAndArrowUpRightToCenter,
    'arrow-down-left': Icons.ArrowDownLeft,
    'arrow-down-long': Icons.ArrowDownLong,
    'arrow-down-right': Icons.ArrowDownRight,
    'arrow-down-short-wide': Icons.ArrowDownShortWide,
    'arrow-down-small-big': Icons.ArrowDownSmallBig,
    'arrow-down-square-triangle': Icons.ArrowDownSquareTriangle,
    'arrow-down-to-arc': Icons.ArrowDownToArc,
    'arrow-down-to-bracket': Icons.ArrowDownToBracket,
    'arrow-down-to-dotted-line': Icons.ArrowDownToDottedLine,
    'arrow-down-to-line': Icons.ArrowDownToLine,
    'arrow-down-to-square': Icons.ArrowDownToSquare,
    'arrow-down-triangle-square': Icons.ArrowDownTriangleSquare,
    'arrow-down-up-across-line': Icons.ArrowDownUpAcrossLine,
    'arrow-down-up-lock': Icons.ArrowDownUpLock,
    'arrow-down-wide-short': Icons.ArrowDownWideShort,
    'arrow-down-z-a': Icons.ArrowDownZa,
    'arrow-down': Icons.ArrowDown,
    'arrow-left-from-line': Icons.ArrowLeftFromLine,
    'arrow-left-long-to-line': Icons.ArrowLeftLongToLine,
    'arrow-left-long': Icons.ArrowLeftLong,
    'arrow-left-to-line-control': Icons.ArrowLeftToLineControl,
    'arrow-left-to-line': Icons.ArrowLeftToLine,
    'arrow-left': Icons.ArrowLeft,
    'arrow-pointer': Icons.ArrowPointer,
    'arrow-right-arrow-left': Icons.ArrowRightArrowLeft,
    'arrow-right-from-arc': Icons.ArrowRightFromArc,
    'arrow-right-from-bracket': Icons.ArrowRightFromBracket,
    'arrow-right-from-line': Icons.ArrowRightFromLine,
    'arrow-right-long-to-line': Icons.ArrowRightLongToLine,
    'arrow-right-long': Icons.ArrowRightLong,
    'arrow-right-to-arc': Icons.ArrowRightToArc,
    'arrow-right-to-bracket': Icons.ArrowRightToBracket,
    'arrow-right-to-city': Icons.ArrowRightToCity,
    'arrow-right-to-line-control': Icons.ArrowRightToLineControl,
    'arrow-right-to-line': Icons.ArrowRightToLine,
    'arrow-right': Icons.ArrowRight,
    'arrow-rotate-left': Icons.ArrowRotateLeft,
    'arrow-rotate-right': Icons.ArrowRotateRight,
    'arrow-trend-down': Icons.ArrowTrendDown,
    'arrow-trend-up': Icons.ArrowTrendUp,
    'arrow-turn-down-left': Icons.ArrowTurnDownLeft,
    'arrow-turn-down-right': Icons.ArrowTurnDownRight,
    'arrow-turn-down': Icons.ArrowTurnDown,
    'arrow-turn-up': Icons.ArrowTurnUp,
    'arrow-up-1-9': Icons.ArrowUp19,
    'arrow-up-9-1': Icons.ArrowUp91,
    'arrow-up-a-z': Icons.ArrowUpAz,
    'arrow-up-arrow-down': Icons.ArrowUpArrowDown,
    'arrow-up-big-small': Icons.ArrowUpBigSmall,
    'arrow-up-from-arc': Icons.ArrowUpFromArc,
    'arrow-up-from-bracket': Icons.ArrowUpFromBracket,
    'arrow-up-from-dotted-line': Icons.ArrowUpFromDottedLine,
    'arrow-up-from-ground-water': Icons.ArrowUpFromGroundWater,
    'arrow-up-from-line': Icons.ArrowUpFromLine,
    'arrow-up-from-square': Icons.ArrowUpFromSquare,
    'arrow-up-from-water-pump': Icons.ArrowUpFromWaterPump,
    'arrow-up-left-from-circle': Icons.ArrowUpLeftFromCircle,
    'arrow-up-left': Icons.ArrowUpLeft,
    'arrow-up-long': Icons.ArrowUpLong,
    'arrow-up-right-and-arrow-down-left-from-center': Icons.ArrowUpRightAndArrowDownLeftFromCenter,
    'arrow-up-right-dots': Icons.ArrowUpRightDots,
    'arrow-up-right-from-square': Icons.ArrowUpRightFromSquare,
    'arrow-up-right': Icons.ArrowUpRight,
    'arrow-up-short-wide': Icons.ArrowUpShortWide,
    'arrow-up-small-big': Icons.ArrowUpSmallBig,
    'arrow-up-square-triangle': Icons.ArrowUpSquareTriangle,
    'arrow-up-to-dotted-line': Icons.ArrowUpToDottedLine,
    'arrow-up-to-line': Icons.ArrowUpToLine,
    'arrow-up-triangle-square': Icons.ArrowUpTriangleSquare,
    'arrow-up-wide-short': Icons.ArrowUpWideShort,
    'arrow-up-z-a': Icons.ArrowUpZa,
    'arrow-up': Icons.ArrowUp,
    'arrows-cross': Icons.ArrowsCross,
    'arrows-down-to-line': Icons.ArrowsDownToLine,
    'arrows-down-to-people': Icons.ArrowsDownToPeople,
    'arrows-from-dotted-line': Icons.ArrowsFromDottedLine,
    'arrows-from-line': Icons.ArrowsFromLine,
    'arrows-left-right-to-line': Icons.ArrowsLeftRightToLine,
    'arrows-left-right': Icons.ArrowsLeftRight,
    'arrows-maximize': Icons.ArrowsMaximize,
    'arrows-minimize': Icons.ArrowsMinimize,
    'arrows-repeat-1': Icons.ArrowsRepeat1,
    'arrows-repeat': Icons.ArrowsRepeat,
    'arrows-retweet': Icons.ArrowsRetweet,
    'arrows-rotate': Icons.ArrowsRotate,
    'arrows-spin': Icons.ArrowsSpin,
    'arrows-split-up-and-left': Icons.ArrowsSplitUpAndLeft,
    'arrows-to-circle': Icons.ArrowsToCircle,
    'arrows-to-dot': Icons.ArrowsToDot,
    'arrows-to-dotted-line': Icons.ArrowsToDottedLine,
    'arrows-to-eye': Icons.ArrowsToEye,
    'arrows-to-line': Icons.ArrowsToLine,
    'arrows-turn-right': Icons.ArrowsTurnRight,
    'arrows-turn-to-dots': Icons.ArrowsTurnToDots,
    'arrows-up-down-left-right': Icons.ArrowsUpDownLeftRight,
    'arrows-up-down': Icons.ArrowsUpDown,
    'arrows-up-to-line': Icons.ArrowsUpToLine,
    asterisk: Icons.Asterisk,
    at: Icons.At,
    'atom-simple': Icons.AtomSimple,
    atom: Icons.Atom,
    'austral-sign': Icons.AustralSign,
    'award-simple': Icons.AwardSimple,
    award: Icons.Award,
    axe: Icons.Axe,
    b: Icons.B,
    backpack: Icons.Backpack,
    'backward-fast': Icons.BackwardFast,
    'backward-step': Icons.BackwardStep,
    backward: Icons.Backward,
    bacteria: Icons.Bacteria,
    bacterium: Icons.Bacterium,
    'badge-check': Icons.BadgeCheck,
    'badge-dollar': Icons.BadgeDollar,
    'badge-percent': Icons.BadgePercent,
    badge: Icons.Badge,
    ban: Icons.Ban,
    bandage: Icons.Bandage,
    'barcode-read': Icons.BarcodeRead,
    'barcode-scan': Icons.BarcodeScan,
    barcode: Icons.Barcode,
    'bars-filter': Icons.BarsFilter,
    'bars-progress': Icons.BarsProgress,
    'bars-sort': Icons.BarsSort,
    'bars-staggered': Icons.BarsStaggered,
    bars: Icons.Bars,
    baseball: Icons.Baseball,
    'basket-shopping-simple': Icons.BasketShoppingSimple,
    'basket-shopping': Icons.BasketShopping,
    'battery-bolt': Icons.BatteryBolt,
    'battery-empty': Icons.BatteryEmpty,
    'battery-exclamation': Icons.BatteryExclamation,
    'battery-full': Icons.BatteryFull,
    'battery-half': Icons.BatteryHalf,
    'battery-low': Icons.BatteryLow,
    'battery-quarter': Icons.BatteryQuarter,
    'battery-slash': Icons.BatterySlash,
    'battery-three-quarters': Icons.BatteryThreeQuarters,
    bee: Icons.Bee,
    'bell-concierge': Icons.BellConcierge,
    'bell-exclamation': Icons.BellExclamation,
    'bell-on': Icons.BellOn,
    'bell-plus': Icons.BellPlus,
    'bell-school-slash': Icons.BellSchoolSlash,
    'bell-school': Icons.BellSchool,
    'bell-slash': Icons.BellSlash,
    bell: Icons.Bell,
    bells: Icons.Bells,
    'binary-circle-check': Icons.BinaryCircleCheck,
    'binary-lock': Icons.BinaryLock,
    'binary-slash': Icons.BinarySlash,
    binary: Icons.Binary,
    binoculars: Icons.Binoculars,
    'blanket-fire': Icons.BlanketFire,
    blanket: Icons.Blanket,
    'block-brick-fire': Icons.BlockBrickFire,
    'block-brick': Icons.BlockBrick,
    'block-question': Icons.BlockQuestion,
    'block-quote': Icons.BlockQuote,
    block: Icons.Block,
    bluetooth: Icons.Bluetooth,
    bold: Icons.Bold,
    'bolt-auto': Icons.BoltAuto,
    'bolt-lightning': Icons.BoltLightning,
    'bolt-slash': Icons.BoltSlash,
    bolt: Icons.Bolt,
    'book-arrow-right': Icons.BookArrowRight,
    'book-arrow-up': Icons.BookArrowUp,
    'book-atlas': Icons.BookAtlas,
    'book-blank': Icons.BookBlank,
    'book-bookmark': Icons.BookBookmark,
    'book-circle-arrow-right': Icons.BookCircleArrowRight,
    'book-circle-arrow-up': Icons.BookCircleArrowUp,
    'book-copy': Icons.BookCopy,
    'book-font': Icons.BookFont,
    'book-open-cover': Icons.BookOpenCover,
    'book-open-reader': Icons.BookOpenReader,
    'book-open': Icons.BookOpen,
    'book-user': Icons.BookUser,
    book: Icons.Book,
    'bookmark-slash': Icons.BookmarkSlash,
    bookmark: Icons.Bookmark,
    books: Icons.Books,
    'border-all': Icons.BorderAll,
    'border-bottom-right': Icons.BorderBottomRight,
    'border-bottom': Icons.BorderBottom,
    'border-center-h': Icons.BorderCenterH,
    'border-center-v': Icons.BorderCenterV,
    'border-inner': Icons.BorderInner,
    'border-left': Icons.BorderLeft,
    'border-none': Icons.BorderNone,
    'border-outer': Icons.BorderOuter,
    'border-right': Icons.BorderRight,
    'border-top-left': Icons.BorderTopLeft,
    'border-top': Icons.BorderTop,
    'box-archive': Icons.BoxArchive,
    'box-ballot': Icons.BoxBallot,
    'box-check': Icons.BoxCheck,
    'box-circle-check': Icons.BoxCircleCheck,
    'box-dollar': Icons.BoxDollar,
    'box-open-full': Icons.BoxOpenFull,
    'box-open': Icons.BoxOpen,
    'box-taped': Icons.BoxTaped,
    'box-tissue': Icons.BoxTissue,
    box: Icons.Box,
    'boxes-packing': Icons.BoxesPacking,
    'boxes-stacked': Icons.BoxesStacked,
    'bracket-curly-right': Icons.BracketCurlyRight,
    'bracket-curly': Icons.BracketCurly,
    'bracket-round-right': Icons.BracketRoundRight,
    'bracket-round': Icons.BracketRound,
    'bracket-square-right': Icons.BracketSquareRight,
    'bracket-square': Icons.BracketSquare,
    'brackets-curly': Icons.BracketsCurly,
    'brackets-round': Icons.BracketsRound,
    'brackets-square': Icons.BracketsSquare,
    'brain-arrow-curved-right': Icons.BrainArrowCurvedRight,
    'brain-circuit': Icons.BrainCircuit,
    brain: Icons.Brain,
    'briefcase-blank': Icons.BriefcaseBlank,
    briefcase: Icons.Briefcase,
    'brightness-low': Icons.BrightnessLow,
    brightness: Icons.Brightness,
    'bring-forward': Icons.BringForward,
    'bring-front': Icons.BringFront,
    broom: Icons.Broom,
    browser: Icons.Browser,
    browsers: Icons.Browsers,
    brush: Icons.Brush,
    bucket: Icons.Bucket,
    'bug-slash': Icons.BugSlash,
    bug: Icons.Bug,
    bugs: Icons.Bugs,
    'building-circle-arrow-right': Icons.BuildingCircleArrowRight,
    'building-circle-check': Icons.BuildingCircleCheck,
    'building-circle-exclamation': Icons.BuildingCircleExclamation,
    'building-circle-xmark': Icons.BuildingCircleXmark,
    'building-columns': Icons.BuildingColumns,
    building: Icons.Building,
    buildings: Icons.Buildings,
    bullhorn: Icons.Bullhorn,
    'bullseye-arrow': Icons.BullseyeArrow,
    'bullseye-pointer': Icons.BullseyePointer,
    bullseye: Icons.Bullseye,
    burst: Icons.Burst,
    'business-time': Icons.BusinessTime,
    c: Icons.C,
    'cabinet-filing': Icons.CabinetFiling,
    'calculator-simple': Icons.CalculatorSimple,
    calculator: Icons.Calculator,
    'calendar-arrow-down': Icons.CalendarArrowDown,
    'calendar-arrow-up': Icons.CalendarArrowUp,
    'calendar-check': Icons.CalendarCheck,
    'calendar-circle-exclamation': Icons.CalendarCircleExclamation,
    'calendar-circle-minus': Icons.CalendarCircleMinus,
    'calendar-circle-plus': Icons.CalendarCirclePlus,
    'calendar-circle-user': Icons.CalendarCircleUser,
    'calendar-clock': Icons.CalendarClock,
    'calendar-day': Icons.CalendarDay,
    'calendar-days': Icons.CalendarDays,
    'calendar-exclamation': Icons.CalendarExclamation,
    'calendar-image': Icons.CalendarImage,
    'calendar-lines-pen': Icons.CalendarLinesPen,
    'calendar-lines': Icons.CalendarLines,
    'calendar-minus': Icons.CalendarMinus,
    'calendar-pen': Icons.CalendarPen,
    'calendar-plus': Icons.CalendarPlus,
    'calendar-range': Icons.CalendarRange,
    'calendar-star': Icons.CalendarStar,
    'calendar-week': Icons.CalendarWeek,
    'calendar-xmark': Icons.CalendarXmark,
    calendar: Icons.Calendar,
    calendars: Icons.Calendars,
    camcorder: Icons.Camcorder,
    'camera-cctv': Icons.CameraCctv,
    'camera-slash': Icons.CameraSlash,
    'camera-viewfinder': Icons.CameraViewfinder,
    'camera-web-slash': Icons.CameraWebSlash,
    'camera-web': Icons.CameraWeb,
    'caret-left': Icons.CaretLeft,
    'caret-right': Icons.CaretRight,
    'caret-up': Icons.CaretUp,
    certificate: Icons.Certificate,
    'chair-office': Icons.ChairOffice,
    chair: Icons.Chair,
    'chalkboard-user': Icons.ChalkboardUser,
    chalkboard: Icons.Chalkboard,
    'chart-area': Icons.ChartArea,
    'chart-bar': Icons.ChartBar,
    'chart-bullet': Icons.ChartBullet,
    'chart-candlestick': Icons.ChartCandlestick,
    'chart-column': Icons.ChartColumn,
    'chart-gantt': Icons.ChartGantt,
    'chart-line-down': Icons.ChartLineDown,
    'chart-line-up': Icons.ChartLineUp,
    'chart-line': Icons.ChartLine,
    'chart-mixed': Icons.ChartMixed,
    'chart-network': Icons.ChartNetwork,
    'chart-pie-simple': Icons.ChartPieSimple,
    'chart-pie': Icons.ChartPie,
    'chart-pyramid': Icons.ChartPyramid,
    'chart-radar': Icons.ChartRadar,
    'chart-scatter-3d': Icons.ChartScatter3D,
    'chart-scatter-bubble': Icons.ChartScatterBubble,
    'chart-scatter': Icons.ChartScatter,
    'chart-simple-horizontal': Icons.ChartSimpleHorizontal,
    'chart-simple': Icons.ChartSimple,
    'chart-tree-map': Icons.ChartTreeMap,
    'chart-user': Icons.ChartUser,
    'chart-waterfall': Icons.ChartWaterfall,
    'check-14px': Icons.Check14Px,
    'check-double': Icons.CheckDouble,
    'check-to-slot': Icons.CheckToSlot,
    check: Icons.Check,
    'chevron-left': Icons.ChevronLeft,
    'chevron-right': Icons.ChevronRight,
    'chevron-up': Icons.ChevronUp,
    'chevrons-down': Icons.ChevronsDown,
    'chevrons-left': Icons.ChevronsLeft,
    'chevrons-right': Icons.ChevronsRight,
    'chevrons-up': Icons.ChevronsUp,
    'circle-0': Icons.Circle0,
    'circle-1': Icons.Circle1,
    'circle-2': Icons.Circle2,
    'circle-3': Icons.Circle3,
    'circle-4': Icons.Circle4,
    'circle-5': Icons.Circle5,
    'circle-6': Icons.Circle6,
    'circle-7': Icons.Circle7,
    'circle-8': Icons.Circle8,
    'circle-9': Icons.Circle9,
    'circle-a': Icons.CircleA,
    'circle-ampersand': Icons.CircleAmpersand,
    'circle-arrow-down-left': Icons.CircleArrowDownLeft,
    'circle-arrow-down-right': Icons.CircleArrowDownRight,
    'circle-arrow-down': Icons.CircleArrowDown,
    'circle-arrow-left': Icons.CircleArrowLeft,
    'circle-arrow-right': Icons.CircleArrowRight,
    'circle-arrow-up-left': Icons.CircleArrowUpLeft,
    'circle-arrow-up-right': Icons.CircleArrowUpRight,
    'circle-arrow-up': Icons.CircleArrowUp,
    'circle-b': Icons.CircleB,
    'circle-bolt': Icons.CircleBolt,
    'circle-book-open': Icons.CircleBookOpen,
    'circle-bookmark': Icons.CircleBookmark,
    'circle-c': Icons.CircleC,
    'circle-calendar': Icons.CircleCalendar,
    'circle-camera': Icons.CircleCamera,
    'circle-caret-down': Icons.CircleCaretDown,
    'circle-caret-left': Icons.CircleCaretLeft,
    'circle-caret-right': Icons.CircleCaretRight,
    'circle-caret-up': Icons.CircleCaretUp,
    'circle-check': Icons.CircleCheck,
    'circle-chevron-down': Icons.CircleChevronDown,
    'circle-chevron-left': Icons.CircleChevronLeft,
    'circle-chevron-right': Icons.CircleChevronRight,
    'circle-chevron-up': Icons.CircleChevronUp,
    'circle-d': Icons.CircleD,
    'circle-dashed': Icons.CircleDashed,
    'circle-divide': Icons.CircleDivide,
    'circle-dollar-to-slot': Icons.CircleDollarToSlot,
    'circle-dollar': Icons.CircleDollar,
    'circle-dot': Icons.CircleDot,
    'circle-down-left': Icons.CircleDownLeft,
    'circle-down-right': Icons.CircleDownRight,
    'circle-down': Icons.CircleDown,
    'circle-e': Icons.CircleE,
    'circle-ellipsis-vertical': Icons.CircleEllipsisVertical,
    'circle-ellipsis': Icons.CircleEllipsis,
    'circle-envelope': Icons.CircleEnvelope,
    'circle-exclamation-check': Icons.CircleExclamationCheck,
    'circle-exclamation': Icons.CircleExclamation,
    'circle-f': Icons.CircleF,
    'circle-g': Icons.CircleG,
    'circle-h': Icons.CircleH,
    'circle-half-stroke': Icons.CircleHalfStroke,
    'circle-half': Icons.CircleHalf,
    'circle-i': Icons.CircleI,
    'circle-info': Icons.CircleInfo,
    'circle-j': Icons.CircleJ,
    'circle-k': Icons.CircleK,
    'circle-l': Icons.CircleL,
    'circle-left': Icons.CircleLeft,
    'circle-location-arrow': Icons.CircleLocationArrow,
    'circle-m': Icons.CircleM,
    'circle-microphone-lines': Icons.CircleMicrophoneLines,
    'circle-microphone': Icons.CircleMicrophone,
    'circle-minus': Icons.CircleMinus,
    'circle-n': Icons.CircleN,
    'circle-nodes': Icons.CircleNodes,
    'circle-notch': Icons.CircleNotch,
    'circle-o': Icons.CircleO,
    'circle-p': Icons.CircleP,
    'circle-pause': Icons.CirclePause,
    'circle-phone-flip': Icons.CirclePhoneFlip,
    'circle-phone-hangup': Icons.CirclePhoneHangup,
    'circle-phone': Icons.CirclePhone,
    'circle-play': Icons.CirclePlay,
    'circle-plus': Icons.CirclePlus,
    'circle-q': Icons.CircleQ,
    'circle-quarter': Icons.CircleQuarter,
    'circle-quarters': Icons.CircleQuarters,
    'circle-question': Icons.CircleQuestion,
    'circle-r': Icons.CircleR,
    'circle-radiation': Icons.CircleRadiation,
    'circle-right': Icons.CircleRight,
    'circle-s': Icons.CircleS,
    'circle-small': Icons.CircleSmall,
    'circle-sort-down': Icons.CircleSortDown,
    'circle-sort-up': Icons.CircleSortUp,
    'circle-sort': Icons.CircleSort,
    'circle-star': Icons.CircleStar,
    'circle-stop': Icons.CircleStop,
    'circle-t': Icons.CircleT,
    'circle-three-quarters': Icons.CircleThreeQuarters,
    'circle-trash': Icons.CircleTrash,
    'circle-u': Icons.CircleU,
    'circle-up-left': Icons.CircleUpLeft,
    'circle-up-right': Icons.CircleUpRight,
    'circle-up': Icons.CircleUp,
    'circle-user': Icons.CircleUser,
    'circle-v': Icons.CircleV,
    'circle-video': Icons.CircleVideo,
    'circle-w': Icons.CircleW,
    'circle-waveform-lines': Icons.CircleWaveformLines,
    'circle-x': Icons.CircleX,
    'circle-xmark': Icons.CircleXmark,
    'circle-y': Icons.CircleY,
    'circle-z': Icons.CircleZ,
    circle: Icons.Circle,
    'clipboard-check': Icons.ClipboardCheck,
    'clipboard-list-check': Icons.ClipboardListCheck,
    'clipboard-list': Icons.ClipboardList,
    'clipboard-question': Icons.ClipboardQuestion,
    'clipboard-user': Icons.ClipboardUser,
    clipboard: Icons.Clipboard,
    'clock-eight-thirty': Icons.ClockEightThirty,
    'clock-eight': Icons.ClockEight,
    'clock-eleven-thirty': Icons.ClockElevenThirty,
    'clock-eleven': Icons.ClockEleven,
    'clock-five-thirty': Icons.ClockFiveThirty,
    'clock-five': Icons.ClockFive,
    'clock-four-thirty': Icons.ClockFourThirty,
    'clock-nine-thirty': Icons.ClockNineThirty,
    'clock-nine': Icons.ClockNine,
    'clock-one-thirty': Icons.ClockOneThirty,
    'clock-one': Icons.ClockOne,
    'clock-rotate-left': Icons.ClockRotateLeft,
    'clock-seven-thirty': Icons.ClockSevenThirty,
    'clock-seven': Icons.ClockSeven,
    'clock-six-thirty': Icons.ClockSixThirty,
    'clock-six': Icons.ClockSix,
    'clock-ten-thirty': Icons.ClockTenThirty,
    'clock-ten': Icons.ClockTen,
    'clock-three-thirty': Icons.ClockThreeThirty,
    'clock-three': Icons.ClockThree,
    'clock-twelve-thirty': Icons.ClockTwelveThirty,
    'clock-twelve': Icons.ClockTwelve,
    'clock-two-thirty': Icons.ClockTwoThirty,
    'clock-two': Icons.ClockTwo,
    clock: Icons.Clock,
    clone: Icons.Clone,
    'cloud-arrow-down': Icons.CloudArrowDown,
    'cloud-arrow-up': Icons.CloudArrowUp,
    'cloud-check': Icons.CloudCheck,
    'cloud-exclamation': Icons.CloudExclamation,
    'cloud-minus': Icons.CloudMinus,
    'cloud-plus': Icons.CloudPlus,
    'cloud-slash': Icons.CloudSlash,
    'cloud-xmark': Icons.CloudXmark,
    cloud: Icons.Cloud,
    'code-simple': Icons.CodeSimple,
    code: Icons.Code,
    'columns-3': Icons.Columns3,
    'comments-question': Icons.CommentsQuestion,
    comments: Icons.Comments,
    'compress-wide': Icons.CompressWide,
    compress: Icons.Compress,
    'computer-speaker': Icons.ComputerSpeaker,
    computer: Icons.Computer,
    'container-storage': Icons.ContainerStorage,
    'conveyor-belt-boxes': Icons.ConveyorBeltBoxes,
    'conveyor-belt-empty': Icons.ConveyorBeltEmpty,
    'conveyor-belt': Icons.ConveyorBelt,
    cookie: Icons.Cookie,
    copy: Icons.Copy,
    copyright: Icons.Copyright,
    'credit-card-blank': Icons.CreditCardBlank,
    'credit-card-front': Icons.CreditCardFront,
    'credit-card': Icons.CreditCard,
    'crop-simple': Icons.CropSimple,
    crop: Icons.Crop,
    'crosshairs-simple': Icons.CrosshairsSimple,
    crosshairs: Icons.Crosshairs,
    cube: Icons.Cube,
    'cubes-stacked': Icons.CubesStacked,
    cubes: Icons.Cubes,
    d: Icons.D,
    'dash-14px': Icons.Dash14Px,
    dash: Icons.Dash,
    database: Icons.Database,
    'delete-left': Icons.DeleteLeft,
    'delete-right': Icons.DeleteRight,
    'desktop-arrow-down': Icons.DesktopArrowDown,
    'desktop-computer': Icons.DesktopComputer,
    desktop: Icons.Desktop,
    'diagram-cells': Icons.DiagramCells,
    'diagram-lean-canvas': Icons.DiagramLeanCanvas,
    'diagram-nested': Icons.DiagramNested,
    'diagram-next': Icons.DiagramNext,
    'diagram-predecessor': Icons.DiagramPredecessor,
    'diagram-previous': Icons.DiagramPrevious,
    'diagram-project': Icons.DiagramProject,
    'diagram-sankey': Icons.DiagramSankey,
    'diagram-subtask': Icons.DiagramSubtask,
    'diagram-successor': Icons.DiagramSuccessor,
    'diagram-venn': Icons.DiagramVenn,
    'dial-high': Icons.DialHigh,
    'dial-low': Icons.DialLow,
    'dial-max': Icons.DialMax,
    'dial-med-low': Icons.DialMedLow,
    'dial-med': Icons.DialMed,
    'dial-min': Icons.DialMin,
    'dial-off': Icons.DialOff,
    dial: Icons.Dial,
    'diamond-exclamation': Icons.DiamondExclamation,
    'diamond-half-stroke': Icons.DiamondHalfStroke,
    'diamond-half': Icons.DiamondHalf,
    'diamond-turn-right': Icons.DiamondTurnRight,
    diamond: Icons.Diamond,
    diploma: Icons.Diploma,
    'display-arrow-down': Icons.DisplayArrowDown,
    'display-code': Icons.DisplayCode,
    'display-slash': Icons.DisplaySlash,
    display: Icons.Display,
    'distribute-spacing-horizontal': Icons.DistributeSpacingHorizontal,
    'distribute-spacing-vertical': Icons.DistributeSpacingVertical,
    divide: Icons.Divide,
    'door-closed': Icons.DoorClosed,
    'door-open': Icons.DoorOpen,
    dove: Icons.Dove,
    'down-from-dotted-line': Icons.DownFromDottedLine,
    'down-from-line': Icons.DownFromLine,
    'down-left-and-up-right-to-center': Icons.DownLeftAndUpRightToCenter,
    'down-left': Icons.DownLeft,
    'down-long': Icons.DownLong,
    'down-right': Icons.DownRight,
    'down-to-bracket': Icons.DownToBracket,
    'down-to-dotted-line': Icons.DownToDottedLine,
    'down-to-line': Icons.DownToLine,
    down: Icons.Down,
    download: Icons.Download,
    'draw-circle': Icons.DrawCircle,
    'draw-polygon': Icons.DrawPolygon,
    'draw-square': Icons.DrawSquare,
    e: Icons.E,
    eject: Icons.Eject,
    'ellipsis-stroke-vertical': Icons.EllipsisStrokeVertical,
    'ellipsis-stroke': Icons.EllipsisStroke,
    'ellipsis-vertical': Icons.EllipsisVertical,
    ellipsis: Icons.Ellipsis,
    'envelope-circle-check': Icons.EnvelopeCircleCheck,
    'envelope-dot': Icons.EnvelopeDot,
    'envelope-open-dollar': Icons.EnvelopeOpenDollar,
    'envelope-open-text': Icons.EnvelopeOpenText,
    'envelope-open': Icons.EnvelopeOpen,
    envelope: Icons.Envelope,
    'envelopes-bulk': Icons.EnvelopesBulk,
    envelopes: Icons.Envelopes,
    equals: Icons.Equals,
    eraser: Icons.Eraser,
    ethernet: Icons.Ethernet,
    'euro-sign': Icons.EuroSign,
    exclamation: Icons.Exclamation,
    'expand-wide': Icons.ExpandWide,
    expand: Icons.Expand,
    'eye-slash': Icons.EyeSlash,
    eye: Icons.Eye,
    f: Icons.F,
    'file-arrow-down': Icons.FileArrowDown,
    'file-arrow-up': Icons.FileArrowUp,
    'file-binary': Icons.FileBinary,
    'file-certificate': Icons.FileCertificate,
    'file-chart-column': Icons.FileChartColumn,
    'file-chart-pie': Icons.FileChartPie,
    'file-check': Icons.FileCheck,
    'file-circle-check': Icons.FileCircleCheck,
    'file-circle-exclamation': Icons.FileCircleExclamation,
    'file-circle-info': Icons.FileCircleInfo,
    'file-circle-minus': Icons.FileCircleMinus,
    'file-circle-plus': Icons.FileCirclePlus,
    'file-circle-question': Icons.FileCircleQuestion,
    'file-circle-xmark': Icons.FileCircleXmark,
    'file-code': Icons.FileCode,
    'file-contract': Icons.FileContract,
    'file-csv': Icons.FileCsv,
    'file-dashed-line': Icons.FileDashedLine,
    'file-excel': Icons.FileExcel,
    'file-exclamation': Icons.FileExclamation,
    'file-export': Icons.FileExport,
    'file-image': Icons.FileImage,
    'file-import': Icons.FileImport,
    'file-invoice': Icons.FileInvoice,
    'file-lines': Icons.FileLines,
    'file-lock': Icons.FileLock,
    'file-magnifying-glass': Icons.FileMagnifyingGlass,
    'file-minus': Icons.FileMinus,
    'file-music': Icons.FileMusic,
    'file-pdf': Icons.FilePdf,
    'file-pen': Icons.FilePen,
    'file-plus-minus': Icons.FilePlusMinus,
    'file-plus': Icons.FilePlus,
    'file-powerpoint': Icons.FilePowerpoint,
    'file-shield': Icons.FileShield,
    'file-signature': Icons.FileSignature,
    'file-slash': Icons.FileSlash,
    'file-spreadsheet': Icons.FileSpreadsheet,
    'file-user': Icons.FileUser,
    'file-video': Icons.FileVideo,
    'file-waveform': Icons.FileWaveform,
    'file-word': Icons.FileWord,
    'file-xmark': Icons.FileXmark,
    'file-zipper': Icons.FileZipper,
    file: Icons.File,
    files: Icons.Files,
    'filter-circle-dollar': Icons.FilterCircleDollar,
    'filter-circle-xmark': Icons.FilterCircleXmark,
    'filter-list': Icons.FilterList,
    'filter-slash': Icons.FilterSlash,
    filter: Icons.Filter,
    filters: Icons.Filters,
    fingerprint: Icons.Fingerprint,
    'flag-swallowtail': Icons.FlagSwallowtail,
    flag: Icons.Flag,
    flashlight: Icons.Flashlight,
    'flask-round-potion': Icons.FlaskRoundPotion,
    'flask-vial': Icons.FlaskVial,
    flask: Icons.Flask,
    'floppy-disk-circle-arrow-right': Icons.FloppyDiskCircleArrowRight,
    'floppy-disk-circle-xmark': Icons.FloppyDiskCircleXmark,
    'floppy-disk-pen': Icons.FloppyDiskPen,
    'floppy-disk': Icons.FloppyDisk,
    'floppy-disks': Icons.FloppyDisks,
    'folder-arrow-down': Icons.FolderArrowDown,
    'folder-arrow-up': Icons.FolderArrowUp,
    'folder-bookmark': Icons.FolderBookmark,
    'folder-closed': Icons.FolderClosed,
    'folder-gear': Icons.FolderGear,
    'folder-grid': Icons.FolderGrid,
    'folder-heart': Icons.FolderHeart,
    'folder-image': Icons.FolderImage,
    'folder-magnifying-glass': Icons.FolderMagnifyingGlass,
    'folder-minus': Icons.FolderMinus,
    'folder-open': Icons.FolderOpen,
    'folder-plus': Icons.FolderPlus,
    'folder-tree': Icons.FolderTree,
    'folder-user': Icons.FolderUser,
    'folder-xmark': Icons.FolderXmark,
    folder: Icons.Folder,
    folders: Icons.Folders,
    'font-case': Icons.FontCase,
    font: Icons.Font,
    'forward-fast': Icons.ForwardFast,
    'forward-step': Icons.ForwardStep,
    forward: Icons.Forward,
    frame: Icons.Frame,
    g: Icons.G,
    'gallery-thumbnails': Icons.GalleryThumbnails,
    gear: Icons.Gear,
    gears: Icons.Gears,
    'glasses-round': Icons.GlassesRound,
    glasses: Icons.Glasses,
    globe: Icons.Globe,
    'greater-than-equal': Icons.GreaterThanEqual,
    'greater-than': Icons.GreaterThan,
    'grid-2-plus': Icons.Grid2Plus,
    'grid-2': Icons.Grid2,
    'grid-4': Icons.Grid4,
    'grid-5': Icons.Grid5,
    'grid-dividers': Icons.GridDividers,
    'grid-horizontal': Icons.GridHorizontal,
    grid: Icons.Grid,
    'grip-dots-vertical': Icons.GripDotsVertical,
    'grip-dots': Icons.GripDots,
    'grip-lines-vertical': Icons.GripLinesVertical,
    'grip-lines': Icons.GripLines,
    'grip-vertical': Icons.GripVertical,
    grip: Icons.Grip,
    'group-arrows-rotate': Icons.GroupArrowsRotate,
    h: Icons.H,
    h1: Icons.H1,
    h2: Icons.H2,
    h3: Icons.H3,
    h4: Icons.H4,
    h5: Icons.H5,
    h6: Icons.H6,
    hammer: Icons.Hammer,
    hashtag: Icons.Hashtag,
    heading: Icons.Heading,
    'headphones-simple': Icons.HeadphonesSimple,
    headphones: Icons.Headphones,
    headset: Icons.Headset,
    heart: Icons.Heart,
    'hexagon-check': Icons.HexagonCheck,
    'hexagon-divide': Icons.HexagonDivide,
    'hexagon-exclamation': Icons.HexagonExclamation,
    'hexagon-image': Icons.HexagonImage,
    'hexagon-minus': Icons.HexagonMinus,
    'hexagon-plus': Icons.HexagonPlus,
    'hexagon-xmark': Icons.HexagonXmark,
    hexagon: Icons.Hexagon,
    'highlighter-line': Icons.HighlighterLine,
    highlighter: Icons.Highlighter,
    'horizontal-rule': Icons.HorizontalRule,
    'house-blank': Icons.HouseBlank,
    'house-building': Icons.HouseBuilding,
    'house-chimney-blank': Icons.HouseChimneyBlank,
    'house-chimney-crack': Icons.HouseChimneyCrack,
    'house-chimney-user': Icons.HouseChimneyUser,
    'house-chimney-window': Icons.HouseChimneyWindow,
    'house-chimney': Icons.HouseChimney,
    'house-circle-check': Icons.HouseCircleCheck,
    'house-circle-exclamation': Icons.HouseCircleExclamation,
    'house-circle-xmark': Icons.HouseCircleXmark,
    'house-crack': Icons.HouseCrack,
    'house-day': Icons.HouseDay,
    'house-laptop': Icons.HouseLaptop,
    'house-lock': Icons.HouseLock,
    'house-user': Icons.HouseUser,
    house: Icons.House,
    hyphen: Icons.Hyphen,
    'i-cursor': Icons.ICursor,
    i: Icons.I,
    icons: Icons.Icons,
    'id-badge': Icons.IdBadge,
    'id-card-clip': Icons.IdCardClip,
    'id-card': Icons.IdCard,
    'image-landscape': Icons.ImageLandscape,
    'image-polaroid-user': Icons.ImagePolaroidUser,
    'image-polaroid': Icons.ImagePolaroid,
    'image-portrait': Icons.ImagePortrait,
    'image-slash': Icons.ImageSlash,
    'image-user': Icons.ImageUser,
    image: Icons.Image,
    'images-user': Icons.ImagesUser,
    images: Icons.Images,
    'inbox-full': Icons.InboxFull,
    'inbox-in': Icons.InboxIn,
    'inbox-out': Icons.InboxOut,
    inbox: Icons.Inbox,
    inboxes: Icons.Inboxes,
    indent: Icons.Indent,
    infinity: Icons.Infinity,
    info: Icons.Info,
    'input-numeric': Icons.InputNumeric,
    'input-pipe': Icons.InputPipe,
    'input-text': Icons.InputText,
    intersection: Icons.Intersection,
    'ipad-landscape': Icons.IpadLandscape,
    iphone: Icons.Iphone,
    italic: Icons.Italic,
    k: Icons.K,
    'kandji-bee': Icons.KandjiBee,
    'kandji-blueprint': Icons.KandjiBlueprint,
    'key-skeleton-left-right': Icons.KeySkeletonLeftRight,
    'key-skeleton': Icons.KeySkeleton,
    key: Icons.Key,
    'keyboard-brightness-low': Icons.KeyboardBrightnessLow,
    'keyboard-brightness': Icons.KeyboardBrightness,
    'keyboard-down': Icons.KeyboardDown,
    'keyboard-left': Icons.KeyboardLeft,
    keyboard: Icons.Keyboard,
    keynote: Icons.Keynote,
    l: Icons.L,
    'laptop-arrow-down': Icons.LaptopArrowDown,
    'laptop-code': Icons.LaptopCode,
    'laptop-computer': Icons.LaptopComputer,
    'laptop-file': Icons.LaptopFile,
    'laptop-mobile': Icons.LaptopMobile,
    'laptop-slash': Icons.LaptopSlash,
    laptop: Icons.Laptop,
    'layer-group': Icons.LayerGroup,
    'layer-minus': Icons.LayerMinus,
    'layer-plus': Icons.LayerPlus,
    'left-from-line': Icons.LeftFromLine,
    'left-long-to-line': Icons.LeftLongToLine,
    'left-long': Icons.LeftLong,
    'left-right': Icons.LeftRight,
    'left-to-line': Icons.LeftToLine,
    left: Icons.Left,
    'less-than-equal': Icons.LessThanEqual,
    'less-than': Icons.LessThan,
    'lightbulb-on': Icons.LightbulbOn,
    'lightbulb-slash': Icons.LightbulbSlash,
    lightbulb: Icons.Lightbulb,
    'line-columns': Icons.LineColumns,
    'line-height': Icons.LineHeight,
    'lines-leaning': Icons.LinesLeaning,
    'link-horizontal-slash': Icons.LinkHorizontalSlash,
    'link-horizontal': Icons.LinkHorizontal,
    'link-simple-slash': Icons.LinkSimpleSlash,
    'link-simple': Icons.LinkSimple,
    'link-slash': Icons.LinkSlash,
    link: Icons.Link,
    'list-check': Icons.ListCheck,
    'list-dropdown': Icons.ListDropdown,
    'list-ol': Icons.ListOl,
    'list-radio': Icons.ListRadio,
    'list-timeline': Icons.ListTimeline,
    'list-tree': Icons.ListTree,
    'list-ul': Icons.ListUl,
    list: Icons.List,
    loader: Icons.Loader,
    'location-arrow': Icons.LocationArrow,
    'location-check': Icons.LocationCheck,
    'location-crosshairs-slash': Icons.LocationCrosshairsSlash,
    'location-crosshairs': Icons.LocationCrosshairs,
    'location-dot-slash': Icons.LocationDotSlash,
    'location-dot': Icons.LocationDot,
    'location-exclamation': Icons.LocationExclamation,
    'location-minus': Icons.LocationMinus,
    'location-pen': Icons.LocationPen,
    'location-pin-lock': Icons.LocationPinLock,
    'location-pin-slash': Icons.LocationPinSlash,
    'location-pin': Icons.LocationPin,
    'location-plus': Icons.LocationPlus,
    'location-question': Icons.LocationQuestion,
    'location-smile': Icons.LocationSmile,
    'location-xmark': Icons.LocationXmark,
    'lock-a': Icons.LockA,
    'lock-hashtag': Icons.LockHashtag,
    'lock-keyhole-open': Icons.LockKeyholeOpen,
    'lock-keyhole': Icons.LockKeyhole,
    'lock-open': Icons.LockOpen,
    lock: Icons.Lock,
    m: Icons.M,
    'magnifying-glass-arrow-right': Icons.MagnifyingGlassArrowRight,
    'magnifying-glass-chart': Icons.MagnifyingGlassChart,
    'magnifying-glass-dollar': Icons.MagnifyingGlassDollar,
    'magnifying-glass-location': Icons.MagnifyingGlassLocation,
    'magnifying-glass-minus': Icons.MagnifyingGlassMinus,
    'magnifying-glass-plus': Icons.MagnifyingGlassPlus,
    'magnifying-glass': Icons.MagnifyingGlass,
    'mailbox-flag-up': Icons.MailboxFlagUp,
    mailbox: Icons.Mailbox,
    'map-location-dot': Icons.MapLocationDot,
    'map-location': Icons.MapLocation,
    'map-pin': Icons.MapPin,
    map: Icons.Map,
    marker: Icons.Marker,
    maximize: Icons.Maximize,
    medal: Icons.Medal,
    megaphone: Icons.Megaphone,
    'memo-circle-check': Icons.MemoCircleCheck,
    'memo-circle-info': Icons.MemoCircleInfo,
    'memo-pad': Icons.MemoPad,
    memo: Icons.Memo,
    memory: Icons.Memory,
    'message-arrow-down': Icons.MessageArrowDown,
    'message-arrow-up-right': Icons.MessageArrowUpRight,
    'message-arrow-up': Icons.MessageArrowUp,
    'message-captions': Icons.MessageCaptions,
    'message-check': Icons.MessageCheck,
    'message-code': Icons.MessageCode,
    'message-dots': Icons.MessageDots,
    'message-exclamation': Icons.MessageExclamation,
    'message-lines': Icons.MessageLines,
    'message-plus': Icons.MessagePlus,
    'message-question': Icons.MessageQuestion,
    'message-quote': Icons.MessageQuote,
    'message-slash': Icons.MessageSlash,
    'message-xmark': Icons.MessageXmark,
    message: Icons.Message,
    messages: Icons.Messages,
    'microchip-ai': Icons.MicrochipAi,
    microchip: Icons.Microchip,
    'microphone-lines-slash': Icons.MicrophoneLinesSlash,
    'microphone-lines': Icons.MicrophoneLines,
    'microphone-slash': Icons.MicrophoneSlash,
    'microphone-stand': Icons.MicrophoneStand,
    microphone: Icons.Microphone,
    minimize: Icons.Minimize,
    minus: Icons.Minus,
    'mobile-button': Icons.MobileButton,
    'mobile-notch': Icons.MobileNotch,
    'mobile-screen-button': Icons.MobileScreenButton,
    'mobile-screen': Icons.MobileScreen,
    mobile: Icons.Mobile,
    'monitor-waveform': Icons.MonitorWaveform,
    n: Icons.N,
    'not-equal': Icons.NotEqual,
    'note-sticky': Icons.NoteSticky,
    note: Icons.Note,
    notebook: Icons.Notebook,
    o: Icons.O,
    'object-exclude': Icons.ObjectExclude,
    'object-group': Icons.ObjectGroup,
    'object-intersect': Icons.ObjectIntersect,
    'object-subtract': Icons.ObjectSubtract,
    'object-ungroup': Icons.ObjectUngroup,
    'object-union': Icons.ObjectUnion,
    'objects-align-bottom': Icons.ObjectsAlignBottom,
    'objects-align-center-horizontal': Icons.ObjectsAlignCenterHorizontal,
    'objects-align-center-vertical': Icons.ObjectsAlignCenterVertical,
    'objects-align-left': Icons.ObjectsAlignLeft,
    'objects-align-right': Icons.ObjectsAlignRight,
    'objects-align-top': Icons.ObjectsAlignTop,
    'objects-column': Icons.ObjectsColumn,
    'octagon-check': Icons.OctagonCheck,
    'octagon-divide': Icons.OctagonDivide,
    'octagon-exclamation': Icons.OctagonExclamation,
    'octagon-minus': Icons.OctagonMinus,
    'octagon-plus': Icons.OctagonPlus,
    'octagon-xmark': Icons.OctagonXmark,
    octagon: Icons.Octagon,
    option: Icons.Option,
    outdent: Icons.Outdent,
    p: Icons.P,
    'page-caret-down': Icons.PageCaretDown,
    'page-caret-up': Icons.PageCaretUp,
    page: Icons.Page,
    'paper-plane-top': Icons.PaperPlaneTop,
    'paper-plane': Icons.PaperPlane,
    'paperclip-vertical': Icons.PaperclipVertical,
    paperclip: Icons.Paperclip,
    'paragraph-left': Icons.ParagraphLeft,
    paragraph: Icons.Paragraph,
    passport: Icons.Passport,
    paste: Icons.Paste,
    pause: Icons.Pause,
    'pen-circle': Icons.PenCircle,
    pen: Icons.Pen,
    'pencil-slash': Icons.PencilSlash,
    pencil: Icons.Pencil,
    'people-group': Icons.PeopleGroup,
    people: Icons.People,
    person: Icons.Person,
    phone: Icons.Phone,
    pipe: Icons.Pipe,
    'plane-up': Icons.PlaneUp,
    plane: Icons.Plane,
    'play-pause': Icons.PlayPause,
    play: Icons.Play,
    plug: Icons.Plug,
    'plus-large': Icons.PlusLarge,
    'plus-minus-small': Icons.PlusMinusSmall,
    'plus-minus': Icons.PlusMinus,
    plus: Icons.Plus,
    podium: Icons.Podium,
    'power-off': Icons.PowerOff,
    'presentation-screen': Icons.PresentationScreen,
    print: Icons.Print,
    q: Icons.Q,
    qrcode: Icons.Qrcode,
    question: Icons.Question,
    'quote-left': Icons.QuoteLeft,
    'quote-right': Icons.QuoteRight,
    quotes: Icons.Quotes,
    r: Icons.R,
    radar: Icons.Radar,
    'rectangle-barcode': Icons.RectangleBarcode,
    'rectangle-code': Icons.RectangleCode,
    'rectangle-terminal': Icons.RectangleTerminal,
    'repeat-1': Icons.Repeat1,
    repeat: Icons.Repeat,
    'reply-all': Icons.ReplyAll,
    reply: Icons.Reply,
    retweet: Icons.Retweet,
    ribbon: Icons.Ribbon,
    'right-from-bracket': Icons.RightFromBracket,
    'right-from-line': Icons.RightFromLine,
    'right-left': Icons.RightLeft,
    'right-long-to-line': Icons.RightLongToLine,
    'right-long': Icons.RightLong,
    'right-to-bracket': Icons.RightToBracket,
    'right-to-line': Icons.RightToLine,
    right: Icons.Right,
    'rotate-left': Icons.RotateLeft,
    'rotate-right': Icons.RotateRight,
    rotate: Icons.Rotate,
    'ruler-horizontal': Icons.RulerHorizontal,
    'ruler-triangle': Icons.RulerTriangle,
    'ruler-vertical': Icons.RulerVertical,
    ruler: Icons.Ruler,
    scissors: Icons.Scissors,
    'screen-users': Icons.ScreenUsers,
    'screwdriver-wrench': Icons.ScrewdriverWrench,
    screwdriver: Icons.Screwdriver,
    scribble: Icons.Scribble,
    'scroll-old': Icons.ScrollOld,
    scroll: Icons.Scroll,
    'sd-card': Icons.SdCard,
    'sd-cards': Icons.SdCards,
    'seal-question': Icons.SealQuestion,
    seal: Icons.Seal,
    'send-back': Icons.SendBack,
    'send-backward': Icons.SendBackward,
    server: Icons.Server,
    'share-all': Icons.ShareAll,
    'share-from-square': Icons.ShareFromSquare,
    'share-nodes': Icons.ShareNodes,
    share: Icons.Share,
    'shield-check': Icons.ShieldCheck,
    'shield-exclamation': Icons.ShieldExclamation,
    'shield-halved': Icons.ShieldHalved,
    'shield-keyhole': Icons.ShieldKeyhole,
    'shield-minus': Icons.ShieldMinus,
    'shield-plus': Icons.ShieldPlus,
    'shield-quartered': Icons.ShieldQuartered,
    'shield-slash': Icons.ShieldSlash,
    'shield-xmark': Icons.ShieldXmark,
    shield: Icons.Shield,
    'sidebar-flip': Icons.SidebarFlip,
    sidebar: Icons.Sidebar,
    'signal-bars-fair': Icons.SignalBarsFair,
    'signal-bars-good': Icons.SignalBarsGood,
    'signal-bars-slash': Icons.SignalBarsSlash,
    'signal-bars-weak': Icons.SignalBarsWeak,
    'signal-bars': Icons.SignalBars,
    'signal-fair': Icons.SignalFair,
    'signal-good': Icons.SignalGood,
    'signal-slash': Icons.SignalSlash,
    'signal-stream-slash': Icons.SignalStreamSlash,
    'signal-stream': Icons.SignalStream,
    'signal-strong': Icons.SignalStrong,
    'signal-weak': Icons.SignalWeak,
    signal: Icons.Signal,
    signature: Icons.Signature,
    'signs-post': Icons.SignsPost,
    'sim-card': Icons.SimCard,
    'sim-cards': Icons.SimCards,
    'slash-back': Icons.SlashBack,
    'slash-forward': Icons.SlashForward,
    slash: Icons.Slash,
    slider: Icons.Slider,
    'sliders-simple': Icons.SlidersSimple,
    'sliders-up': Icons.SlidersUp,
    sliders: Icons.Sliders,
    'sort-down': Icons.SortDown,
    'sort-up': Icons.SortUp,
    sort: Icons.Sort,
    sparkles: Icons.Sparkles,
    speaker: Icons.Speaker,
    speakers: Icons.Speakers,
    'spell-check': Icons.SpellCheck,
    'spinner-third': Icons.SpinnerThird,
    spinner: Icons.Spinner,
    split: Icons.Split,
    'square-0': Icons.Square0,
    'square-1': Icons.Square1,
    'square-2': Icons.Square2,
    'square-3': Icons.Square3,
    'square-4': Icons.Square4,
    'square-5': Icons.Square5,
    'square-6': Icons.Square6,
    'square-7': Icons.Square7,
    'square-8': Icons.Square8,
    'square-9': Icons.Square9,
    'square-a-lock': Icons.SquareALock,
    'square-a': Icons.SquareA,
    'square-ampersand': Icons.SquareAmpersand,
    'square-arrow-down-left': Icons.SquareArrowDownLeft,
    'square-arrow-down-right': Icons.SquareArrowDownRight,
    'square-arrow-down': Icons.SquareArrowDown,
    'square-arrow-left': Icons.SquareArrowLeft,
    'square-arrow-right': Icons.SquareArrowRight,
    'square-arrow-up-left': Icons.SquareArrowUpLeft,
    'square-arrow-up-right': Icons.SquareArrowUpRight,
    'square-arrow-up': Icons.SquareArrowUp,
    'square-b': Icons.SquareB,
    'square-bolt': Icons.SquareBolt,
    'square-c': Icons.SquareC,
    'square-caret-down': Icons.SquareCaretDown,
    'square-caret-left': Icons.SquareCaretLeft,
    'square-caret-right': Icons.SquareCaretRight,
    'square-caret-up': Icons.SquareCaretUp,
    'square-check': Icons.SquareCheck,
    'square-chevron-down': Icons.SquareChevronDown,
    'square-chevron-left': Icons.SquareChevronLeft,
    'square-chevron-right': Icons.SquareChevronRight,
    'square-chevron-up': Icons.SquareChevronUp,
    'square-code': Icons.SquareCode,
    'square-d': Icons.SquareD,
    'square-dashed-circle-plus': Icons.SquareDashedCirclePlus,
    'square-dashed': Icons.SquareDashed,
    'square-down-left': Icons.SquareDownLeft,
    'square-down-right': Icons.SquareDownRight,
    'square-down': Icons.SquareDown,
    'square-e': Icons.SquareE,
    'square-ellipsis-vertical': Icons.SquareEllipsisVertical,
    'square-ellipsis': Icons.SquareEllipsis,
    'square-envelope': Icons.SquareEnvelope,
    'square-exclamation': Icons.SquareExclamation,
    'square-f': Icons.SquareF,
    'square-full': Icons.SquareFull,
    'square-g': Icons.SquareG,
    'square-h': Icons.SquareH,
    'square-i': Icons.SquareI,
    'square-info': Icons.SquareInfo,
    'square-j': Icons.SquareJ,
    'square-k': Icons.SquareK,
    'square-kanban': Icons.SquareKanban,
    'square-l': Icons.SquareL,
    'square-left': Icons.SquareLeft,
    'square-list': Icons.SquareList,
    'square-m': Icons.SquareM,
    'square-minus': Icons.SquareMinus,
    'square-n': Icons.SquareN,
    'square-o': Icons.SquareO,
    'square-p': Icons.SquareP,
    'square-plus': Icons.SquarePlus,
    'square-q': Icons.SquareQ,
    'square-question': Icons.SquareQuestion,
    'square-quote': Icons.SquareQuote,
    'square-r': Icons.SquareR,
    'square-right': Icons.SquareRight,
    'square-ring': Icons.SquareRing,
    'square-s': Icons.SquareS,
    'square-share-nodes': Icons.SquareShareNodes,
    'square-sliders-vertical': Icons.SquareSlidersVertical,
    'square-sliders': Icons.SquareSliders,
    'square-small': Icons.SquareSmall,
    'square-t': Icons.SquareT,
    'square-terminal': Icons.SquareTerminal,
    'square-this-way-up': Icons.SquareThisWayUp,
    'square-u': Icons.SquareU,
    'square-up-left': Icons.SquareUpLeft,
    'square-up-right': Icons.SquareUpRight,
    'square-up': Icons.SquareUp,
    'square-user': Icons.SquareUser,
    'square-v': Icons.SquareV,
    'square-w': Icons.SquareW,
    'square-x': Icons.SquareX,
    'square-xmark': Icons.SquareXmark,
    'square-y': Icons.SquareY,
    'square-z': Icons.SquareZ,
    square: Icons.Square,
    'star-sharp': Icons.StarSharp,
    star: Icons.Star,
    stop: Icons.Stop,
    stopwatch: Icons.Stopwatch,
    store: Icons.Store,
    strikethrough: Icons.Strikethrough,
    subscript: Icons.Subscript,
    suitcase: Icons.Suitcase,
    'sun-bright': Icons.SunBright,
    sun: Icons.Sun,
    superscript: Icons.Superscript,
    symbols: Icons.Symbols,
    t: Icons.T,
    'table-cells-large': Icons.TableCellsLarge,
    'table-cells': Icons.TableCells,
    'table-columns': Icons.TableColumns,
    'table-layout': Icons.TableLayout,
    'table-list': Icons.TableList,
    'table-picnic': Icons.TablePicnic,
    'table-pivot': Icons.TablePivot,
    'table-rows': Icons.TableRows,
    'table-tree': Icons.TableTree,
    table: Icons.Table,
    'tablet-button': Icons.TabletButton,
    'tablet-rugged': Icons.TabletRugged,
    'tablet-screen-button': Icons.TabletScreenButton,
    'tablet-screen': Icons.TabletScreen,
    tablet: Icons.Tablet,
    tablets: Icons.Tablets,
    tag: Icons.Tag,
    tags: Icons.Tags,
    'tally-1': Icons.Tally1,
    'tally-2': Icons.Tally2,
    'tally-3': Icons.Tally3,
    'tally-4': Icons.Tally4,
    tally: Icons.Tally,
    tape: Icons.Tape,
    terminal: Icons.Terminal,
    'text-height': Icons.TextHeight,
    'text-size': Icons.TextSize,
    'text-slash': Icons.TextSlash,
    'text-width': Icons.TextWidth,
    text: Icons.Text,
    'thought-bubble': Icons.ThoughtBubble,
    thumbtack: Icons.Thumbtack,
    ticket: Icons.Ticket,
    tilde: Icons.Tilde,
    'timeline-arrow': Icons.TimelineArrow,
    timeline: Icons.Timeline,
    timer: Icons.Timer,
    'toggle-large-off': Icons.ToggleLargeOff,
    'toggle-large-on': Icons.ToggleLargeOn,
    'toggle-off': Icons.ToggleOff,
    'toggle-on': Icons.ToggleOn,
    toolbox: Icons.Toolbox,
    trademark: Icons.Trademark,
    'trash-arrow-up': Icons.TrashArrowUp,
    'trash-can-arrow-up': Icons.TrashCanArrowUp,
    'trash-can-check': Icons.TrashCanCheck,
    'trash-can-clock': Icons.TrashCanClock,
    'trash-can-list': Icons.TrashCanList,
    'trash-can-plus': Icons.TrashCanPlus,
    'trash-can-slash': Icons.TrashCanSlash,
    'trash-can-undo': Icons.TrashCanUndo,
    'trash-can-xmark': Icons.TrashCanXmark,
    'trash-can': Icons.TrashCan,
    'trash-check': Icons.TrashCheck,
    'trash-clock': Icons.TrashClock,
    'trash-list': Icons.TrashList,
    'trash-plus': Icons.TrashPlus,
    'trash-slash': Icons.TrashSlash,
    'trash-undo': Icons.TrashUndo,
    'trash-xmark': Icons.TrashXmark,
    trash: Icons.Trash,
    'triangle-exclamation': Icons.TriangleExclamation,
    triangle: Icons.Triangle,
    'turn-down-right': Icons.TurnDownRight,
    'turn-down': Icons.TurnDown,
    'turn-up': Icons.TurnUp,
    tv: Icons.Tv,
    underline: Icons.Underline,
    union: Icons.Union,
    'universal-access': Icons.UniversalAccess,
    'unlock-keyhole': Icons.UnlockKeyhole,
    unlock: Icons.Unlock,
    'up-down-left-right': Icons.UpDownLeftRight,
    'up-down': Icons.UpDown,
    'up-from-bracket': Icons.UpFromBracket,
    'up-from-dotted-line': Icons.UpFromDottedLine,
    'up-from-line': Icons.UpFromLine,
    'up-left': Icons.UpLeft,
    'up-long': Icons.UpLong,
    'up-right-and-down-left-from-center': Icons.UpRightAndDownLeftFromCenter,
    'up-right-from-square': Icons.UpRightFromSquare,
    'up-right': Icons.UpRight,
    'up-to-dotted-line': Icons.UpToDottedLine,
    'up-to-line': Icons.UpToLine,
    up: Icons.Up,
    upload: Icons.Upload,
    'usb-drive': Icons.UsbDrive,
    'user-check': Icons.UserCheck,
    'user-clock': Icons.UserClock,
    'user-gear': Icons.UserGear,
    'user-group': Icons.UserGroup,
    'user-large-slash': Icons.UserLargeSlash,
    'user-large': Icons.UserLarge,
    'user-lock': Icons.UserLock,
    'user-magnifying-glass': Icons.UserMagnifyingGlass,
    'user-minus': Icons.UserMinus,
    'user-pen': Icons.UserPen,
    'user-plus': Icons.UserPlus,
    'user-shield': Icons.UserShield,
    'user-slash': Icons.UserSlash,
    'user-tag': Icons.UserTag,
    'user-unlock': Icons.UserUnlock,
    'user-xmark': Icons.UserXmark,
    user: Icons.User,
    'users-between-lines': Icons.UsersBetweenLines,
    'users-gear': Icons.UsersGear,
    'users-line': Icons.UsersLine,
    'users-slash': Icons.UsersSlash,
    users: Icons.Users,
    v: Icons.V,
    vault: Icons.Vault,
    'virus-slash': Icons.VirusSlash,
    virus: Icons.Virus,
    viruses: Icons.Viruses,
    'volume-high': Icons.VolumeHigh,
    'volume-low': Icons.VolumeLow,
    'volume-off': Icons.VolumeOff,
    'volume-slash': Icons.VolumeSlash,
    'volume-xmark': Icons.VolumeXmark,
    volume: Icons.Volume,
    w: Icons.W,
    wallet: Icons.Wallet,
    'watch-apple': Icons.WatchApple,
    'watch-calculator': Icons.WatchCalculator,
    'wave-pulse': Icons.WavePulse,
    'wave-sine': Icons.WaveSine,
    'wave-square': Icons.WaveSquare,
    'wave-triangle': Icons.WaveTriangle,
    'waveform-lines': Icons.WaveformLines,
    waveform: Icons.Waveform,
    'wifi-exclamation': Icons.WifiExclamation,
    'wifi-fair': Icons.WifiFair,
    'wifi-slash': Icons.WifiSlash,
    'wifi-weak': Icons.WifiWeak,
    wifi: Icons.Wifi,
    'window-flip': Icons.WindowFlip,
    'window-frame-open': Icons.WindowFrameOpen,
    'window-frame': Icons.WindowFrame,
    'window-maximize': Icons.WindowMaximize,
    'window-minimize': Icons.WindowMinimize,
    'window-restore': Icons.WindowRestore,
    window: Icons.Window,
    'wrench-simple': Icons.WrenchSimple,
    wrench: Icons.Wrench,
    'x-ray': Icons.XRay,
    x: Icons.X,
    'xmark-large': Icons.XmarkLarge,
    'xmark-small': Icons.XmarkSmall,
    xmark: Icons.Xmark,
    'xmarks-lines': Icons.XmarksLines,
    y: Icons.Y,
    z: Icons.Z,
    'app-store': Icons.AppStore,
    'app-store-ios': Icons.AppStoreIos,
};
